<template>
  <div>
    <v-icon color="amber accent-4" @click="mostrarModal = true"
      >mdi-pencil</v-icon
    >
    <v-dialog
      v-model="mostrarModal"
      transition="dialog-bottom-transition"
      fullscreen
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="mostrarModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Despiece</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn dark text @click="mostrarModal = false"> Salir </v-btn>
          </v-toolbar-items>
        </v-toolbar>

          <div class="d-flex justify-space-between mt-3">
          <div class="d-flex">
            <span class="text-h5 mx-3">Información.</span>
            
          </div>
        </div> 

        <v-card class="ma-3 allB" :disabled="editar">
          <v-row style="margin: 0px !important">
            <v-col cols="12" sm="12" md="12">
              <v-card-text>
                <v-col cols="12" sm="12" md="12" class="d-flex">
                  <v-text-field
                    label="DESPIECE"
                    v-model="infoDespiece.DESPIECE_ID"
                    filled
                    dense
                    prepend-icon="mdi-information-variant"
                    
                  />
                </v-col>
                 <v-col cols="12" sm="12" md="12" class="d-flex">
                  <v-text-field
                    label="PRODUCTO"
                    v-model="producto_despiece"
                    filled
                    dense
                    prepend-icon="mdi-information-variant"
                    
                  />
                </v-col>
                  
                <div>
                  <!-- SECCION FECHA -->
                  <v-menu
                    label="FECHA DESPIECE"
                    v-model="infoDespiece.FECHA_DESPIECE"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    
                    
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fechaSalida"
                        label="Fecha salida"
                        prepend-icon="mdi-calendar"
                        filled
                        light
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      >
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="fechaSalida"
                      @input="modalFecha1 = false"
                      :min="minFecha[0]"
                    >
                    </v-date-picker>
                  </v-menu>
                </div>
              </v-card-text>
              <div class="d-flex">
          <v-text-field 
          class="mx-1" 
          label="Almacen Salida" 
          v-model="infoDespiece.ALMACEN_SALIDA" 
          :items="almacenes" 
          item-text="NOMBRE" 
          item-value="ALMACEN_ID" 
          readonly
          
          return-object/>

          <v-text-field 
          class="mx-1" 
          label="Almacen Entrada (opcional)" 
          v-model="infoDespiece.ALMACEN_ENTRADA" 
          :items="almacenes" 
          item-text="NOMBRE" 
          item-value="NOMBRE" 
          readonly
          
          return-object/>
        </div>

        <v-divider></v-divider>
      
        <v-row>
          <v-col cols="12" sm="12" md="12" class="">
            <v-data-table :headers="columnasExcel" :items="articulos" class="tamTexto grey lighten-3 allB">
              <template v-slot:header="{props:{headers} }">
                <thead>
                  <tr>
                    <th :colspan="headers.length">
                      Despiece
                    </th>
                  </tr>
                </thead>
              </template>

              <template v-slot:[`item.data-table-select`]="{item}">
          <v-checkbox v-if="item.ID !=1"
          :disabled="item.ID == 1"
          class="pa-0 ma-0"
          :ripple="false"
          v-model="articuloSeleccionado"
          :multiple="true"
          :value="item"
          hide-details
          @click="clear()"></v-checkbox> 
        </template>
            </v-data-table>  

                  
          </v-col>

        </v-row>
      <v-divider></v-divider>
            </v-col>
            <v-divider
              vertical
              style="border-color: rgba(0, 0, 0, 0.42)"
            ></v-divider>
          </v-row>
          <v-divider></v-divider>

           
        <!-- TABLA ARTICULOS -->
        <!-- <v-data-table
                  class="elevation-1 grey lighten-2 tamTexto"
                  :headers="columnas"
                  :items="datosTabla"
                  :search="buscador"
                  :loading="cargando"
                  :footer-props="{
                    'items-per-page-options': [5, 10, 15, 20],
                  }"
                  :items-per-page="5"
                >
        </v-data-table> -->
          <v-card-actions class="d-flex justify-space-around">
            <!-- <v-btn class="primary darken-1" text dark @click="mostrarModal = false" :loading="cargando"
              >OK</v-btn
            > -->
            <v-btn
              class="primary darken-1"
              text
              @click="guardarCambios"
              :loading="cargando"
              >{{textoBoton}}</v-btn>

          </v-card-actions>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  props: ["infoDespiece"],

  data() {
    return {
      despieceID: 0,
      
      mostrarModal:         false,
      editar:               false,
      fechaSeleccionada:    "",
      modalFecha:           false,
      minFecha:             "",
      fechaSalida:          '',
  
      buscador:     "",
      buscador2:    "",
      buscador3:    "",
      cargando:     false,
      datosDespieceDetalle: null,
      almacenSeleccionado:null,
      almacenEntrada:null,
      almacenes: [],
      datosTabla: [],
      articuloSeleccionado:[],
      articulos: [],

      columnasExcel: [

        {text: "CLAVE MSP",      value: "CLAVE_MSP",       class: "primary dark white--text",},
        //{text: "CANTIDAD",       value: "CANTIDAD",        class: "primary dark white--text",},
      ],

      producto_despiece:'',
      //cantidad_producto: '',
    
    };
  },

  computed: {
    ...mapGetters(["getURLAPI", "getFechaActual", "getUsuario"]),

    // guardarCambios: function () {
    //   if ( this.dividirArt )
    //     return "Crear Nuevo Despiece"
    //   else 
    //     return  "Guardar Cambios"
    // },

     textoBoton: function () {
      if ( this.infoDespiece.DESPIECE_ID )
        return "OK"
      else 
        return  "OK"
    },
    
  },

  methods: {
    // ---------------------------------------------------------------------------
    async getAlmacenes(){
      this.almacenes = (await axios.get(`${this.getURLAPI}/Show/allStorage`)).data;
      
    },

    async getDetalle(){

       this.cargando = false;
       //console.log(this.articulos);

       this.articulos = (await axios.get(`${this.getURLAPI}/Despiece/mostrarDespieceDetalle/${this.infoDespiece.DESPIECE_ID}`)).data
       this.despieceID = this.articulos[0].DESPIECE_ID;
       this.fechaSalida = this.articulos[0].FECHA_DESPIECE;
       this.almacenEntrada = this.articulos[0].ALMACEN_ENTRADA;
       this.almacenSeleccionado = this.articulos[0].ALMACEN_SELECCIONADO;
       this.producto_despiece = this.articulos[0].CLAVE_PRODUCTO;
       //this.cantidad_producto = this.articulos[1].CANTIDAD;
   
    },

    log(){
      console.log(this.infoDespiece);
    },
    
    //--------------------------------------------------------------------------
      // async getInfoDespiece()
      // {
      //   try{

      // const datosDesp = (await axios.get(`${this.getURLAPI}/Despiece/mostrarDespiece/${this.infoDespiece.DESPIECE_ID}`)).data;
       
      // this.despieceID = datosDesp[0].DESPIECE_ID;
      // this.despAlmacenSeleccionado = datosDesp[0].ALMACEN_SELECCIONADO;
      // this.despAlmacenEntrada = datosDesp[0].ALMACEN_ENTRADA;
      // this.despFecha = datosDesp[0].FECHA.split(" ")[0];
      

      // this.fechaSeleccionada = this.despFecha;
      // this.almacenSeleccionado = this.despAlmacenSeleccionado;
      // this.almacenEntrada = this.despAlmacenEntrada;
      // this.getDetalle();
      
      // }
      // catch(err){
      //   this.$root.vtoast.show({
      //         message: "Error al conectar con el servidor",
      //         color: "red darken-1",
      //         timer: 10000,
      //         icon: "mdi-alert-circle-outline",
      //       });
      // }
      // },
  
   
    //------------------------------------------------------------------------------
    guardarCambios()
    {
     
       this.$emit("actualizarTabla");
          this.mostrarDialogo = false;
    },
    // ------------------------------------------------------------------------------
    LOG(){
      console.log(this.articuloSeleccionado)
    },

    clear(){
      console.clear();
    },
    // -------------------------------------------------------------------------------
      mostrarExcel() {
      if (this.file == null) {
        //console.log("agrega un archivo");
        return;
      } else {
        console.log(this.file);
        let datosForm = new FormData();
        datosForm.append("EXCEL", this.file);

        axios
          .post(`${this.getURLAPI}/Despiece/vistaPrevia`, datosForm)
          .then(({ data }) => {
            this.datosExcel = data;
            //console.log(data);
            this.dialog = false;
          });
      }
    },
  },

  created() {
    
    //this.getInfoDespiece();
    this.getAlmacenes();
    this.getDetalle();
    //this.obtenerDespieceDetalle();
    this.despieceID = this.$route.params['id'];

  },
};
</script>

<style>
  
  #tabla td{
    font-size:inherit!important;
    /* height: 48px; */
  }

  #tabla input{
    font: 100;
  }

</style>
